import { CargoType } from '@planning/app/api'
import { FieldStore, FormStore } from '@tom-ui/utils'
import { action, makeObservable } from 'mobx'

export type VesselVisitCargoFormStoreType = {
  cargoType: CargoType | null
  dischargeEstimate: number
  loadEstimate: number
  restowEstimate: number
}

export class VesselVisitCargoFormStore extends FormStore<VesselVisitCargoFormStoreType> {
  cargoType: FieldStore<CargoType | null>
  dischargeEstimate: FieldStore<number | undefined>
  loadEstimate: FieldStore<number | undefined>
  restowEstimate: FieldStore<number | undefined>

  constructor(initialValues?: Partial<VesselVisitCargoFormStoreType>) {
    super(initialValues)

    makeObservable(this, {
      setData: action,
      patchData: action,
      reset: action,
      updateInitialValueWithCurrentData: action,
    })

    this.cargoType = new FieldStore(initialValues?.cargoType ?? null)
    this.dischargeEstimate = new FieldStore<number | undefined>(initialValues?.dischargeEstimate)
    this.loadEstimate = new FieldStore<number | undefined>(initialValues?.loadEstimate)
    this.restowEstimate = new FieldStore<number | undefined>(initialValues?.restowEstimate)
  }

  setData(data: Partial<VesselVisitCargoFormStoreType>) {
    this.cargoType.setValue(data.cargoType ?? CargoType.Container)
    this.dischargeEstimate.setValue(data.dischargeEstimate ?? 0)
    this.loadEstimate.setValue(data.loadEstimate ?? 0)
    this.restowEstimate.setValue(data.restowEstimate ?? 0)
  }

  patchData(data: Partial<VesselVisitCargoFormStoreType>) {
    if (data.cargoType) {
      this.cargoType.setValue(data.cargoType)
    }

    if (data.dischargeEstimate) {
      this.dischargeEstimate.setValue(data.dischargeEstimate)
    }

    if (data.loadEstimate) {
      this.loadEstimate.setValue(data.loadEstimate)
    }

    if (data.restowEstimate) {
      this.restowEstimate.setValue(data.restowEstimate)
    }
  }

  reset() {
    this.setData(this.initialValues)
  }

  // todo: test
  updateInitialValueWithCurrentData() {
    this.initialValues = this.data
    this.cargoType.updateInitialValue(this.cargoType.value)
    this.dischargeEstimate.updateInitialValue(this.dischargeEstimate.value)
    this.loadEstimate.updateInitialValue(this.loadEstimate.value)
    this.restowEstimate.updateInitialValue(this.restowEstimate.value)
  }

  get data(): VesselVisitCargoFormStoreType {
    return {
      cargoType: this.cargoType.value,
      dischargeEstimate: this.dischargeEstimate.value ?? 0,
      loadEstimate: this.loadEstimate.value ?? 0,
      restowEstimate: this.restowEstimate.value ?? 0,
    }
  }

  get isDirty(): boolean {
    return (
      this.cargoType.dirty ||
      this.dischargeEstimate.dirty ||
      this.loadEstimate.dirty ||
      this.restowEstimate.dirty
    )
  }
}
